export const EnumEstadosBeneficios = {
    PENDIENTE: 'pendiente',
    APROBADO: 'aprobado',
    RECHAZADO: 'rechazado',
    INACTIVO: 'inactivo'
}